import { MDXRemote, MDXRemoteSerializeResult } from 'next-mdx-remote';

import { ContentWrapper, LegalTextStack } from '@collab/atoms';

import { legalComponents } from 'components/mdxComponents/legalMdx';

type MdxLegalPageProps = {
  mdxContent: MDXRemoteSerializeResult;
};

const MdxLegalPage: React.FC<MdxLegalPageProps> = ({ mdxContent }) => (
  <ContentWrapper>
    <LegalTextStack>
      <MDXRemote {...mdxContent} components={legalComponents} />
    </LegalTextStack>
  </ContentWrapper>
);

export default MdxLegalPage;
